<template>
    <legacy-group-report-template v-model:current-report-template-id="currentReportTemplateId"
                           v-model:display-section="displaySection"
                           v-model:for-group="forGroup"
                           v-model:ran-report="$data._reportSuccessfullySent"
                           v-model:reload-data="$data._reloadTable"
                           v-model:running-errors="$data._errorSending"
                           v-model:running-report="$data._runningReport"
                           v-model:settings="$data._settings"
                           :can-edit="permissions.can('manage_room_condition_report')"
                           :default-settings="defaultSettings"
                           :interval="$data._interval"
                           report-name="room-condition-report"
                           @useStandardReporting="setUseStandardReporting"
                           @reset-settings="resetSelectedZones"

    >
        <template #create-settings>
            <legacy-room-condition-report-settings
                v-model:settings="$data._settings"
            ></legacy-room-condition-report-settings>
        </template>

        <template #edit-settings>
            <legacy-room-condition-report-settings
                v-model:settings="$data._settings"
            ></legacy-room-condition-report-settings>
        </template>

        <template #run-options="props">
            <legacy-zone-interval-selection v-model:end-of-interval="endOfInterval"
                                     v-model:interval="$data._interval"
                                     v-model:max-date="maxDate"
                                     v-model:min-date="minDate"
                                     v-model:selected-zones="$data._selectedZones"
                                     :zones="zonesByGroup[props.groupId]"
                                     :timezone="timezone"
                                     @run-report="runReport(currentReportTemplateId)"
            ></legacy-zone-interval-selection>
        </template>
    </legacy-group-report-template>
</template>

<script>
import axios from "axios"
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import ReportHomeModal from "@/components/GroupReports/Legacy/LegacyReportHomeModal.vue";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";
import BaseReport from "@/components/Reports/BaseReport";
import ZoneIntervalSelection from "@/components/GroupReports/Legacy/LegacyZoneIntervalSelection.vue";
import DetailedAlarmReportSettings from "@/components/GroupReports/Legacy/LegacyDetailedAlarmReportSettings.vue";
import AjaxTable from "@/components/elements/AjaxTable";
import Select2 from "@/components/elements/select2";
import SlideOverPanel from "@/components/elements/SlideOverPanel";
import ButtonRedSecondary from "@/components/elements/buttons/ButtonRedSecondary";
import ButtonGreenPrimary from "@/components/elements/buttons/ButtonGreenPrimary";
import GroupReportTemplate from "@/components/GroupReports/Legacy/LegacyGroupReportTemplate.vue";
import RoomConditionReportSettings from "@/components/GroupReports/Legacy/LegacyRoomConditionReportSettings.vue";

export default {
    name: "GroupRoomConditionReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
        RoomConditionReportSettings,
        GroupReportTemplate,
        ButtonGreenPrimary,
        ButtonRedSecondary,
        SlideOverPanel,
        AjaxTable,
        DetailedAlarmReportSettings, ZoneIntervalSelection, BaseReport, ReportHomeModal, ButtonBlueSecondary, Select2,
        Menu, MenuButton, MenuItem, MenuItems,
    },
    props: {
        autoSendHours: {
            type: Array
        },
        zones: {
            type: Object,
        },
        zonesByGroup: {
            type: Object,
        },
        minDate: {
            type: Date
        },
        maxDate: {
            type: Date
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
        timezone: {
            type: String,
            default: 'America/New_York',
        },
    },
    data() {
        return {
            displaySection: null,

            endOfInterval: new Date(),
            _selectedZones: [],
            _templateName: '',
            _groupId: null,

            _data: [],

            _reloadTable: false,
            _settings: {},
            _runningReport: false,
            _reportSuccessfullySent: false,
            _errorSending: [],

            currentReportTemplateId: null,
            forGroup: false,


            _interval: 'daily',
            _semiMonthHalf: 'first',
            _selectedMeters: [],
            _prepareSettingsFunction: null,

            useStandardReporting: false,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        runReport(reportTemplateId = null) {
            console.log(`Running report on DAR file w/ reportTemplateIndex: ${reportTemplateId}`)
            let params = {}
            if (reportTemplateId !== null) {
                params['reportTemplateId'] = reportTemplateId
                params['forGroup'] = this.forGroup
            } else {
                params['interval'] = this.$data._interval
            }

            params['end'] = this.$data.endOfInterval
            params['selected_zones'] = this.$data._selectedZones
            params['sendTime'] = this.send

            // return
            this.$data._runningReport = true
            axios.post(this.company.buildCompanyRoute('group-reports/room-condition-report'), params)
                .then(response => {
                    let data = response.data
                    console.log(`Report Queued successfully, data is`)
                    console.log(data)
                    // Clear the error logs, since the report is done.
                    this.$data._reportSuccessfullySent = true
                    this.$data._errorSending = []
                })
                .catch(response => {
                    let data = response.data
                    console.log(`Report Queued Failed, data is`)
                    console.log(data)
                    // Store the logs from errors to show.
                    this.$data._errorSending = data
                })
                .finally(() => {
                    console.log(`Report finalizing`)
                    // Finish the sending of the report.
                    this.$data._runningReport = false
                })
        },
        resetSelectedZones() {
            this.$data._selectedZones = []
        },
        resetTemplateRun() {
            this.currentReportTemplateIndex = null
            this.forGroup = false
        },
        setUseStandardReporting(event) {
            this.useStandardReporting = event
        },
    },
    computed: {},
    watch: {
        settings (val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        },
    },
}
</script>

<style scoped>

</style>